export default __webpack_public_path__ + "static/media/lotte.08167da6.png";